// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"addToCart_is-mob__R25g3","is-desk":"addToCart_is-desk__Sx5np","container":"addToCart_container__MO9Qy"};